import { KanbanDefaultStates } from "../../ProjectList/CanvasKanban";
import { ProjectStatus } from "../index";

export interface StatusItem {
  key: string;
  status: string;
  isDefault: boolean;
  type: string;
}

export function findStatusByIdOrKey(
  statusId: string,
  customProjectStatuses: ProjectStatus[],
): ProjectStatus | undefined {
  const status = customProjectStatuses.find((s) => s.id === statusId);
  if (status) return status;

  const isDefaultStatusKey =
    Object.keys(KanbanDefaultStates).includes(statusId);
  if (isDefaultStatusKey) {
    return customProjectStatuses.find(
      (s) =>
        s.isDefault && (s.defaultStatusKey === statusId || s.id === statusId),
    );
  }

  return undefined;
}

export function isDefaultStatusName(
  statusName: string,
  allProjectStatuses?: StatusItem[],
): boolean {
  if (
    Object.values(KanbanDefaultStates).includes(
      statusName as KanbanDefaultStates,
    )
  ) {
    return true;
  }

  if (allProjectStatuses?.length) {
    return allProjectStatuses.some(
      (item) => item.status === statusName && item.isDefault,
    );
  }

  return false;
}

export function getStatusNameFromStateKey(
  stateKey: string,
  customProjectStatuses?: ProjectStatus[],
  allProjectStatuses?: StatusItem[],
  stateToIssues?: Record<string, any>,
): string {
  if (stateToIssues?.[stateKey]) {
    return stateKey;
  }

  const defaultStatusName =
    KanbanDefaultStates[stateKey as keyof typeof KanbanDefaultStates];
  if (defaultStatusName) {
    if (allProjectStatuses?.length) {
      const renamedDefault = allProjectStatuses.find(
        (item) =>
          item.isDefault &&
          (item.key === stateKey || item.status === defaultStatusName),
      );
      if (renamedDefault) {
        return renamedDefault.status;
      }
    }
    return defaultStatusName;
  }

  if (customProjectStatuses?.length) {
    const customStatus = customProjectStatuses.find((s) => s?.id === stateKey);
    if (customStatus) {
      return customStatus.name;
    }
  }

  if (allProjectStatuses?.length) {
    const statusItem = allProjectStatuses.find(
      (item) => item.key === stateKey || item.status === stateKey,
    );
    if (statusItem) {
      return statusItem.status;
    }
  }

  return KanbanDefaultStates.BACKLOG;
}

export function getStatusNameFromKey(
  key: string | null,
  customProjectStatuses?: ProjectStatus[],
): string | null {
  if (!key) return null;

  const defaultStatusName =
    KanbanDefaultStates[key as keyof typeof KanbanDefaultStates];
  if (defaultStatusName) {
    return defaultStatusName;
  }

  if (customProjectStatuses?.length) {
    const customStatus = customProjectStatuses.find((s) => s.id === key);
    if (customStatus) {
      return customStatus.name;
    }
  }

  return null;
}
